// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page{min-height:800px;text-align:center;position:relative}.error-page .container{position:absolute;top:40%;transform:translateY(-50%);width:100%}.error-page p{margin:30px 0}.error-page div.no-route-button{width:200px;background-color:#00669f;line-height:50px;display:inline-block;color:#fff;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
